import ActividadAplicacionPlantelActions from "./ActividadAplicacionPlantelActions";

const ActividadAplicacionPlantelRow = ({ actividad, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{actividad.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(actividad.nombre || actividad.actividad || "-"),
        }}
      />
      <td>{actividad.talento_nombre || "-"}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            actividad.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {actividad.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <ActividadAplicacionPlantelActions actividad={actividad} />
        </span>
      </td>
    </tr>
  );
};

const ActividadesAplicacionPlantelTable = ({ actividades, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Actividad</th>
            <th>Talento</th>
            <th>Estado</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {actividades.map((actividad) => (
            <ActividadAplicacionPlantelRow
              key={actividad.id}
              actividad={actividad}
              search={search}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ActividadesAplicacionPlantelTable;
